import React from 'react';


const LoginHeader = () => {
  return (
    <div className="text-center mb-8">
      {/* Logo */}
      <div className="flex items-center justify-center space-x-3 mb-6">
        <div className="w-12 h-12 flex items-center justify-center">
          <img 
            src="/assets/images/Kein_Titel_900_x_1024_px_2_-1757417528542.png" 
            alt="Vierdimensional Logo" 
            className="w-12 h-12 object-contain"
          />
        </div>
        <span className="text-2xl font-bold text-secondary font-heading">
          Vierdimensional
        </span>
      </div>

      {/* Welcome Text */}
      <div className="space-y-2">
        <h1 className="text-3xl font-bold text-foreground font-heading">
          Willkommen zurück
        </h1>
        <p className="text-muted-foreground">
          Melden Sie sich an, um Ihre AI-Agenten zu verwalten
        </p>
      </div>
    </div>
  );
};

export default LoginHeader;